import React from 'react';
import { Col, Typography } from "antd";
import { useForm, ValidationError } from '@formspree/react';

import CustomInput from "../../shared/custom-input/custom-input";
import CustomTextArea from "../../shared/custom-text-area/custom-text-area";
import CustomRow from "../../shared/costum-row/costum-row";
import CustomButton from "../../shared/custom-button/custom-button";

import { BUTTON_VARIANTS } from "../../constants/styles";
import { INPUT_TYPES } from "../../constants/props";

import "./styles.scss";

const { Text } = Typography;

const ContactForm = () => {
  const [state, handleSubmit] = useForm("mzzgkaak");

  if (state.succeeded) {
    return (
      <CustomRow className="ContactForm" justify="center">
        <Col span={24}>
          <Text className="ContactForm-success">Thanks for your message! We'll get back to you soon.</Text>
        </Col>
      </CustomRow>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <CustomRow
        gutter={[0, 20]}
        className="ContactForm"
        justify={"start"}
        align={"top"}
      >
        <Col span={24}>
          <CustomInput 
            type={INPUT_TYPES.TEXT} 
            placeholder="Your name"
            name="name"
            id="name"
          />
          <ValidationError 
            prefix="Name" 
            field="name"
            errors={state.errors}
          />
        </Col>
        <Col span={24}>
          <CustomInput
            type={INPUT_TYPES.EMAIL}
            placeholder="Your email address"
            name="email"
            id="email"
          />
          <ValidationError 
            prefix="Email" 
            field="email"
            errors={state.errors}
          />
        </Col>
        <Col span={24}>
          <CustomTextArea
            rows={8}
            placeholder="Tell us about your project requirements"
            name="message"
            id="message"
          />
          <ValidationError 
            prefix="Message" 
            field="message"
            errors={state.errors}
          />
        </Col>
        <Col>
          <CustomButton 
            btnVariant={BUTTON_VARIANTS.FORM}
            htmlType="submit"
            disabled={state.submitting}
          >
            <Text className="ContactForm-button-text">
              {state.submitting ? 'Sending...' : 'Send'}
            </Text>
          </CustomButton>
        </Col>
      </CustomRow>
    </form>
  );
};

export default ContactForm;
